export default (() => {
	document.addEventListener('DOMContentLoaded', function () {
		const excerptCollapse = document.getElementById('excerptCollapse')
		if(excerptCollapse){
			excerptCollapse.addEventListener('show.bs.collapse', function () {
				console.log('hello world')
				document.getElementById('textFade').classList.add('d-none');
				const showExcerptButton = document.getElementById('showExcerptButton')
				showExcerptButton.classList.add('d-none');
			})
		}
	})		
})()
